import Vue from 'vue'
import Router from 'vue-router'
import pageLeafletIndex from '@/components/pageLeafletIndex'
Vue.use(Router)
/**
 * @testmap 测试
 * @smallMap 生产
 * @testmap 测试
*/
export default new Router({
  base:'/travelwalkman/order/dySmallMap',
  mode: "history",
  routes: [
    {
      path: '/',
      name: 'pageLeafletIndex',
      component: pageLeafletIndex,
    },
    {
      path: '{*}',
      name: 'pageLeafletIndex',
      component: pageLeafletIndex
    },
    {
      path: '/404',
      name: 'pageLeafletIndex',
      component: pageLeafletIndex
    },
    // {
    //   path: '@/components/manuscript',
    //   name: 'manuscript',
    //   // component: pageLeafletIndex
    // },
    {
      path: '/travelwalkman/order/testmap',
      name: 'pageLeafletIndex',
      component: pageLeafletIndex
    },
    {
      path: '/index.html',
      name: 'pageLeafletIndex',
      component: pageLeafletIndex
    }
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js